import React, { Component } from "react";
export default class DotCountingSection extends Component {
  render() {
    var {
      dot_countring_score,
      dot_status_1,
      dot_status_2,
      dot_status_3,
      dot_status_4,
    } = this.props.data;
    return (
      <div className="row border border-dark">
        <div className="col-lg-12">
          <ul
            style={{
              paddingLeft: 20,
              fontSize: 19,
              paddingTop: 40,
            }}
          >
            <li style={{ listStyle: "square" }}>
              Administration:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  Progress from left to right and top to bottom to move through
                  the squares. All squares should be attempted.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Scoring:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  One point for each correct box.
                </li>
              </ul>
            </li>
            <li style={{ listStyle: "square" }}>
              Say:
              <ul style={{ paddingLeft: 40 }}>
                <li style={{ listStyle: "circle" }}>
                  “I would like you to count how many dots are in each box, but
                  without pointing to them”.
                </li>
              </ul>
            </li>
          </ul>
          <hr />
          <div className="row">
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>1) Correct Answer:</b> 10
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/dot-images/1.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={dot_status_1 == "1" ? true : false}
                  name="dot_status_1"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>2) Correct Answer:</b> 8
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/dot-images/2.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={dot_status_2 == "1" ? true : false}
                  name="dot_status_2"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>3) Correct Answer:</b> 7
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/dot-images/3.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={dot_status_3 == "1" ? true : false}
                  name="dot_status_3"
                />
              </div>
            </div>
            <div className="col-lg-6 col-12 col-sm-6 col-md-6">
              <p
                style={{
                  fontSize: 17,
                  listStyle: "circle",
                }}
              >
                <b>4) Correct Answer:</b> 9
              </p>
              <div className="d-flex align-items-baseline">
                <img
                  className="dot-image"
                  src={require("../../../../../../assets/img/dot-images/4.png")}
                  alt="scorpion"
                />
                <input
                  readonly
                  className="position-relative"
                  style={{ width: 20, left: 7 }}
                  type="checkbox"
                  checked={dot_status_4 == "1" ? true : false}
                  name="dot_status_4"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6" style={{ borderLeft: "1px solid #000" }}>
          <div>
            <br />
            <span className="fs-19">Score (0-4) </span>
            <input
              type="number"
              disabled
              name="dot_countring_score"
              value={dot_countring_score}
              className="ecas-input-field"
              placeholder="Score"
            />
          </div>
        </div>
      </div>
    );
  }
}
